export const FETCH_MERCHANT = 'merchantPage/FETCH_MERCHANT';
